import { config } from "../../../config";

export function formatNumberForLocale(input: number): string {
  return input.toLocaleString(config.locale, { maximumFractionDigits: 20 });
}
